import { AuthPermission } from "../../services/auth.service";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface ProtectedComponentType {
  requiredPermission: AuthPermission[];
  children: JSX.Element;
}

const ProtectedComponent = ({ requiredPermission, children }: ProtectedComponentType) => {
  const { currentUser } = useSelector((state: RootState) => state.currentUser);
  const userPermissions = currentUser?.permissions ?? [];
  if (requiredPermission.length === 0) return children;
  const permissions = requiredPermission.map(permission => {
    return userPermissions.includes(permission);
  });
  return permissions.includes(false) ? null : children;
};

export default ProtectedComponent;
